import { match as category } from "../../../src/params/category.ts";
import { match as lang } from "../../../src/params/lang.ts";
import { match as modal } from "../../../src/params/modal.ts";
import { match as provider } from "../../../src/params/provider.ts";
import { match as slug } from "../../../src/params/slug.ts";

export const matchers = { category, lang, modal, provider, slug };